import React, { useState ,useEffect } from 'react'
import axios from 'axios'
import './resourceCentre.css';
import { BeatLoader } from 'react-spinners'
import { css } from '@emotion/core'
import DatasetSection from './DatasetSection';
import { Grid } from '@material-ui/core';

export default function ResourceCenter() {

    const [ loading, setLoading ] = useState(false)

    const loaderStyle = css`
        display: flex;
        align-items: center;
        justify-content: center
    `

    useEffect(() => {
        setLoading(true);
        axios.get('https://hackmakers.com/wp-json/wp/v2/pages/1062')
        .then((res) => {
            document.getElementById("resource-content").innerHTML = res.data.content.rendered;
            setLoading(false);
        })
        .catch((err) => {console.log(err)})
    },[]) 

    return (
        <div>

            <Grid container spacing = {3}>
                <DatasetSection />
            </Grid>

          <div id="resource-centre-page">
            <div id="resource-content">
                {/* loaded content will be put into here */}
            </div>
          </div>
          :
          <BeatLoader 
            css = { loaderStyle }
            size = {48}
            color = "#CC2E72" 
            loading={loading}
        /> 
       </div>
    )
}

